import { Injectable } from '@angular/core';
import { RouteDiagnosticService } from './route-diagnostic.service';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class RouteInterceptorService {
  private isEnabled = true;

  constructor(private diagnosticService: RouteDiagnosticService) {
    // Activer le diagnostic automatique
    this.enableDiagnostic();
  }

  /**
   * Active le diagnostic automatique
   */
  enableDiagnostic(): void {
    this.isEnabled = true;
    console.log('🔍 Diagnostic automatique des routes activé');
    
    // Intercepter les appels à google.maps.DirectionsService
    this.interceptGoogleMapsDirections();
    
    // Intercepter les appels à L.Routing
    this.interceptLeafletRouting();
  }

  /**
   * Désactive le diagnostic automatique
   */
  disableDiagnostic(): void {
    this.isEnabled = false;
    console.log('🔍 Diagnostic automatique des routes désactivé');
  }

  /**
   * Intercepte les appels à Google Maps Directions Service
   */
  private interceptGoogleMapsDirections(): void {
    if (typeof google !== 'undefined' && google.maps && google.maps.DirectionsService) {
      const originalRoute = google.maps.DirectionsService.prototype.route;
      const self = this; // Capturer la référence au service
      
      google.maps.DirectionsService.prototype.route = function(request: any, callback: any) {
        if (self.isEnabled) {
          console.log('🔍 Interception Google Maps Directions:', {
            origin: request.origin,
            destination: request.destination,
            waypoints: request.waypoints,
            travelMode: request.travelMode,
            timestamp: new Date().toISOString()
          });
        }
        
        return originalRoute.call(this, request, (result: any, status: any) => {
          if (self.isEnabled && status === google.maps.DirectionsStatus.OK) {
            const route = result.routes[0];
            let totalDurationInSeconds = 0;
            route.legs.forEach((leg: any) => {
              totalDurationInSeconds += leg.duration?.value || 0;
            });
            const totalDistance = route.legs.reduce((acc: number, leg: any) => acc + leg.distance!.value, 0);
            
            console.log('✅ Résultat Google Maps Directions:', {
              distance: totalDistance,
              duration: totalDurationInSeconds,
              timestamp: new Date().toISOString()
            });

            // Diagnostic automatique des distances
            if (request.origin && request.destination) {
              self.diagnosticService.diagnoseDistanceDifferences(request.origin, request.destination);
              self.diagnosticService.checkDistanceConsistency(request.origin, request.destination);
            }
          }
          callback(result, status);
        });
      };
    }
  }

  /**
   * Intercepte les appels à Leaflet Routing
   */
  private interceptLeafletRouting(): void {
    // Cette méthode sera appelée quand Leaflet est chargé
    if (typeof L !== 'undefined' && L.Routing) {
      console.log('🔍 Leaflet Routing détecté');
    }
  }

  /**
   * Génère un rapport de diagnostic
   */
  generateReport(): void {
    this.diagnosticService.generateDiagnosticReport();
  }

  /**
   * Efface l'historique de diagnostic
   */
  clearHistory(): void {
    this.diagnosticService.clearHistory();
  }
} 